module.exports = __webpack_public_path__ + "img/file-text.8dbfd3ff.svg";